export default __webpack_public_path__ + "static/media/dbd_primary.a4867604.png";